<template>
  <div class="wb_box">
    <!-- 归属选择 -->
    <div class="search_box belongs">
      <div class="belong_title">客户归属: </div>
      <el-select v-model="belongID" placeholder="请选择" @change="selectedSaleman" class="search_select search_inputBox">
        <el-option v-for="item in belongList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button class="benchBtn right" size="mini" @click="showOptionLog" v-if="module.indexOf(',customer-index-log,')!=-1">操作记录</el-button>
    </div>
    <!-- 数据展示 组件-->
    <statistic :showData="statisticData" :profitData="profitData"/>
    <!-- 查询 -->
    <div class="search_box clearfix mar_top">
      <el-input v-model="searchParams.name" class="search_input search_inputBox" placeholder="客户名称" size="mini"></el-input>
      <el-select v-model="searchParams.customer_source_id" class="search_select search_inputBox" multiple collapse-tags placeholder="客户来源" @visible-change="getSelectList('customerSource')">
        <el-option v-for="list in selectMap.customerSource" :key="list.id" :value="list.id" :label="list.name"></el-option>
      </el-select>
      <el-select v-model="searchParams.customer_attribute_id" class="search_select search_inputBox" multiple collapse-tags placeholder="客户属性" @visible-change="getSelectList('customerAttribute')">
        <el-option v-for="list in selectMap.customerAttribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
      </el-select>
      <el-input v-model="searchParams.main_business" class="search_select search_inputBox" placeholder="主营项目" size="mini"></el-input> 
      <el-input v-model="searchParams.breed" class="search_input search_inputBox" placeholder="采购品类" size="mini"></el-input>
      <el-date-picker v-model="searchParams.start_time" type="date" placeholder="交易开始时间" class="search_input search_inputBox" size="mini"></el-date-picker>
      <el-date-picker v-model="searchParams.end_time" type="date" placeholder="交易结束时间" class="search_input search_inputBox" size="mini"></el-date-picker>    
      <el-input v-model="searchParams.history_salesman_name" v-show="showHistoryMan" class="search_input search_inputBox" placeholder="历史归属" size="mini"></el-input>
      <div style="width: 130px; float: left;">
        <div class="reset fcolor" @click="reset">重置</div>
        <el-button class="publicBtn" style="margin-bottom: 7px;" @click="searchCopy">查询</el-button>
      </div>
      <div class="globalFilterBtn"  @click="filterDialogVisible=!filterDialogVisible;"></div>
    </div>
    <!-- tabs -->
    <el-tabs v-model="activeName" @tab-click="handleClick" class="wb_tabs special">
      <el-tab-pane :label="'全部客户('+ t_customer_all +')'" name="first">
        <allcustomersingle v-if="refresh" @parentHandle="handleSonEmit" @pageChangeEvent="handlePageEvent" @singleSelected="handleSingleSel" @refreshCustomerData="refreshCustomerData" @sortAllCustomer="sortAllCustomer" :customerColumn="customerColumn" :customerData="allcustomerData" :pages="allPages" :isLoading="isLoading"/>
      </el-tab-pane>
      <el-tab-pane :label="'待办事项(' + t_backlog + ')'" name="todo">
        <todotoday @todoHandle="handleSonEmit" @todoPageChangeEvent="handleTodoPageEvent" @filterTodayEvent="handleFilterToday" @refreshTodoList="refreshTodoList" @singleSelected="handleSingleSelToDo" @sortEstrangedCustomer="sortEstrangedCustomer" :todoData="todoData" :pages="todoPages" :isLoading="isLoading"/>
      </el-tab-pane>
      <el-tab-pane :label="'10天未联系(' + t_customer_10 + ')'" name="1">
        <estranged @grandEstranged="handleSonEmit" @pageChangeEvent="handlePageEvent" @sortEstrangedCustomer="sortEstrangedCustomer" :customerColumn="customerColumn" :unContactData="allcustomerData" :pages="allPages" :isLoading="isLoading"/>
      </el-tab-pane>
      <el-tab-pane :label="'30天未联系(' + t_customer_30 + ')'" name="2">
        <estranged @grandEstranged="handleSonEmit" @pageChangeEvent="handlePageEvent" @sortEstrangedCustomer="sortEstrangedCustomer" :customerColumn="customerColumn" :unContactData="allcustomerData" :pages="allPages" :isLoading="isLoading"/>
      </el-tab-pane>
      <el-tab-pane :label="'60天未联系(' + t_customer_60 + ')'" name="3">
        <estranged @grandEstranged="handleSonEmit" @pageChangeEvent="handlePageEvent" @sortEstrangedCustomer="sortEstrangedCustomer" :customerColumn="customerColumn" :unContactData="allcustomerData" :pages="allPages" :isLoading="isLoading"/>
      </el-tab-pane>
      <el-tab-pane :label="'90天未联系(' + t_customer_90 + ')'" name="4">
        <estranged @grandEstranged="handleSonEmit" @pageChangeEvent="handlePageEvent" @sortEstrangedCustomer="sortEstrangedCustomer" :customerColumn="customerColumn" :unContactData="allcustomerData" :pages="allPages" :isLoading="isLoading"/>
      </el-tab-pane>
      <el-tab-pane :label="'90天未成交(' + t_customer_unsettled_90 + ')'" name="5">
        <estranged @grandEstranged="handleSonEmit" @pageChangeEvent="handlePageEvent" @sortEstrangedCustomer="sortEstrangedCustomer" :customerColumn="customerColumn" :unContactData="allcustomerData" :pages="allPages" :isLoading="isLoading"/> 
      </el-tab-pane>
      <el-tab-pane :label="'公共客户池(' + t_customer_common + ')'" v-if="module.indexOf(',customer-common-list,')!=-1" name="6">
        <allcustomer type="common" @parentHandle="handleSonEmit" @refreshPublic="refreshPublicData" @pageChangeEvent="handlePageEvent" @sortCommonCustomer="sortCommonCustomer" :customerColumn="customerColumn" :customerData="commonCustomerData" :pages="allPages" :isLoading="isLoading"/>
      </el-tab-pane>
      <el-tab-pane :label="'企业黑名单(' + t_customer_hei + ')'" v-if="module.indexOf(',customer-hei-list,')!=-1" name="7">
        <allcustomer type="blacklist" @parentHandle="handleSonEmit" @refreshBacklist="refreshBacklistData"  @pageChangeEvent="handlePageEvent" @sortBlackCustomer="sortBlackCustomer" :customerColumn="customerColumn" :customerData="blackListData" :pages="allPages" :isLoading="isLoading"/> 
      </el-tab-pane>
      <el-tab-pane label="客户采购TOP10" name="last_before" style="overflow: auto">
        <toppurchase :amount="topAmount" :customer="topCustomer" @changeTypeEvent="changeTypeEvent"/>  
      </el-tab-pane>
    </el-tabs>
    <!-- 字段过滤 START -->
    <filter-fields :tableData="filter" scene="customer.index.list" :isGlobal="false" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
    <!-- 字段过滤 END -->
  </div>
</template>

<script>
import eventBus from '../../../eventBus'
import statistic from './statistic'
import allcustomer from './components/allcustomer'
import allcustomersingle from './components/allcustomerSingle'
import todotoday from './components/todoToday'
import estranged from './components/estranged'
import toppurchase from './components/toppurchase'

export default {
  components: {
    statistic,
    allcustomer,
    todotoday,
    estranged,
    toppurchase,
    allcustomersingle
  },
  data(){
    return {
      module:localStorage.dw_erp_power_code,
      is_admin: null,//超级管理员
      belongID: null,
      belongList: [],
      //查询下拉列表
      selectMap:{
        customerSource:[],
        customerAttribute:[]
      },

      activeName: 'first',

      allcustomerData: null,//全部客户
      unContactData: null,//未联系客户
      commonCustomerData: null,//公共池客户
      blackListData: null,//黑名单
      todoData: null,//待办数据
      topAmount: null,//采购排名数据
      topCustomer: null,//采购排名数据

      //分页数据
      allPages: {
        last_page: 0,
        total: 0,
        current_page: 1,
        per_page: 20,
      },
      todoPages: {
        last_page: 0,
        total: 0,
        current_page: 1,
        per_page: 20,
      },
      //查询参数
      searchParams:{
        per_page: 20,
        page: 1,
        salesman_id: null,
        name: '',
        customer_source_id: null,
        customer_attribute_id: null, 
        main_business:'',
        breed:'',
        start_time: '',
        end_time: ''
      },
      //今日待办
      todoParams: {
        per_page: 20,
        page: 1,
        salesman_id: null,
        is_today: 0
      },
      //销售统计数据
      statisticData: {
        all_square_count: 0,
        all_sell_count: 0,
        sell_money_count:0,
        is_admin:0,
        m_square_count: 0,
        m_sell_count: 0,
        m_customer_count: 0
      },
      profitData: '0',//毛利润
      //客户统计数据
      total: {
        customer_all: 0,
        backlog: 0,
        customer_10: 0,
        customer_30: 0,
        customer_60: 0,
        customer_90: 0,
        customer_unsettled_90: 0,
        customer_common: 0,
        customer_hei: 0
      },
      t_customer_all: 0,
      t_backlog: 0,
      t_customer_10: 0,
      t_customer_30: 0,
      t_customer_60: 0,
      t_customer_90: 0,
      t_customer_unsettled_90: 0,
      t_customer_common: 0,
      t_customer_hei: 0,
      tabsType: '',
      is_today: 1,
      login_id: null,
      unDealDay: 90,
      filter: [],
      filterDialogVisible: false,
      customerColumn: '',
      showHistoryMan: false, //历史归属
      refresh: true,
      isLoading: false
    }
  },
  methods: {
    //用户操作日志
    showOptionLog(){
      	var obj={};
				obj.label="客户操作记录";
				obj.name="客户操作记录";
				obj.content="customerOperationLog";
        this.$emit("middleEvent",obj);
    },
    //客户归属列表
    getBelongList(){
      this.postFunc("erp/user.select", {show_disabled:1}, res=>{
        let is_admin = localStorage.getItem('dw_erp_all_customer')   // 所有客户权限  
        let login_id = localStorage.getItem('dw_erp_user_id')        // 登录用户ID
        let resData = res.data.data
        
        this.login_id = login_id
        this.is_admin = is_admin == 1 ? true : false      
        this.belongID = +login_id  // 默认获取当前用户ID
        if(this.is_admin){
          resData.unshift({id: 'all', name: '全部'})
          this.belongID = 'all'
        }
        this.belongList = resData
        this.getFilterData()       //全部客户
        this.getStatisticData()    //销售统计
        this.getProfitData()       //销售统计-毛利润数据
        this.getCustomerStaData()  //客户统计数据
      })
    },
    //客户归属筛选 全部客户
    getFilterData(){
      let obj = {}
      if(this.belongID == 'all'){
        obj.salesman_id = ''
      }else{
        obj.salesman_id = Number(this.belongID)
      }
      this.isLoading = true
      this.postFunc("erp/customer.index.list", obj, (res)=>{       
        this.filter = res.data.data.column
        this.customerColumn = ","+res.data.data.fields.join(",").toString()+",";    
        let resData = res.data.data.data
        resData.forEach(item=>{
          item.visit_time = item.visit_time ? this.formatTimeSecond(item.visit_time*1000) : ''
          item.deal_time = item.deal_time ? this.formatTimeSecond(item.deal_time*1000) : ''
          item.checked = false
        })
        this.isLoading = false   
        this.allcustomerData = resData
        let obj = {}
        obj.total = Number(res.data.data.total)
        obj.per_page = Number(res.data.data.per_page)
        obj.current_page = Number(res.data.data.current_page)
        obj.last_page = Number(res.data.data.last_page)
        this.allPages = obj       
      })
    },
    //获取销售统计数据
    getStatisticData(){
      let obj = {}
      if(this.belongID == 'all'){
        obj.salesman_id = ''
      }else{
        obj.salesman_id = Number(this.belongID)
      }
      this.postFunc("erp/customer.index.history", obj, (res)=>{
        this.statisticData = res.data.data      
      })
    },
    //获取毛利润数据
    getProfitData(){
      let obj = {}
      if(this.belongID == 'all'){
        obj.salesman_id = ''
      }else{
        obj.salesman_id = Number(this.belongID)
      }
      this.postFunc("erp/customer.index.maoli", obj, (res)=>{
        this.profitData = res.data.data.sell_profit_count      
      })
    },
    //获取客户统计数据
    getCustomerStaData(){      
      let obj = Object.assign({}, this.searchParams)
      obj.salesman_id = this.belongID == 'all' ? '' : Number(this.belongID)
      // obj.start_time = this.formatTimeZero(obj.start_time);
      // obj.end_time = this.formatTimeZero(obj.end_time);
      obj.start_time = obj.start_time ? Date.parse(new Date(obj.start_time))/1000 : ''
      obj.end_time = obj.start_time ? (Date.parse(new Date(obj.end_time))/1000 + 86399) : ''
      if(obj.hasOwnProperty('history_salesman_name') &&  this.tabsType != '6'){
        delete obj.history_salesman_name
      }
      this.postFunc("erp/customer.index.total", obj, (res)=>{
        res.data.data.customer_common = res.data.data.customer_common == null ? 0 : res.data.data.customer_common
        res.data.data.customer_hei = res.data.data.customer_hei == null ? 0 : res.data.data.customer_hei
        let total = res.data.data
        this.t_customer_all = total.customer_all
        this.t_backlog = total.backlog
        this.t_customer_10 = total.customer_10
        this.t_customer_30 = total.customer_30
        this.t_customer_60 = total.customer_60
        this.t_customer_90 = total.customer_90
        this.t_customer_unsettled_90 = total.customer_unsettled_90
        this.t_customer_common = total.customer_common
        this.t_customer_hei = total.customer_hei
      })
    },
    //获取客户数据
    getList(params){
      this.isLoading = true
      // this.allcustomerData = []
      if(this.belongID == 'all'){
        params.salesman_id = ''
      }
      params.start_time = this.formatTimeZero(params.start_time);
      params.end_time = this.formatTimeZero(params.end_time);
      // params.start_time = params.start_time ? Date.parse(new Date(params.start_time))/1000 : ''
      // params.end_time = params.start_time ? (Date.parse(new Date(params.end_time))/1000 + 86399) : ''
      this.postFunc("erp/customer.index.list", params, (res)=>{
        let resData = res.data.data.data
        resData.forEach(item=>{
          item.visit_time = item.visit_time ? this.formatTimeSecond(item.visit_time*1000) : ''
          item.deal_time = item.deal_time ? this.formatTimeSecond(item.deal_time*1000) : ''
          item.checked = false  //添加checked 单选
        })
        this.isLoading = false
        this.allcustomerData = resData
        let obj = {}
        obj.total = Number(res.data.data.total)
        obj.per_page = Number(res.data.data.per_page)
        obj.current_page = Number(res.data.data.current_page)
        obj.last_page = Number(res.data.data.last_page)
        this.allPages = obj
        if(this.activeName == 'first'){
          this.t_customer_all = res.data.data.total
        }
        if(this.activeName == '1'){
          this.t_customer_10 = res.data.data.total
        }
        if(this.activeName == '2'){
          this.t_customer_30 = res.data.data.total
        }
        if(this.activeName == '3'){
          this.t_customer_60 = res.data.data.total
        }
        if(this.activeName == '4'){
          this.t_customer_90 = res.data.data.total
        }
        if(this.activeName == '5'){
          this.t_customer_unsettled_90 = res.data.data.total
        }
        if(this.activeName == '6'){
          this.t_customer_common = res.data.data.total
        }
        if(this.activeName == '7'){
          this.t_customer_hei = res.data.data.total
        }      
      })
    },
    //获取黑名单数据
    getBlackListData(params){
      this.isLoading = true
      // this.blackListData = []
      if(this.belongID == 'all'){
        params.salesman_id = ''
      }
      params.start_time = params.start_time ? Date.parse(new Date(params.start_time))/1000 : ''
      params.end_time = params.start_time ? Date.parse(new Date(params.end_time))/1000 : ''
      this.postFunc("erp/customer.hei.list", params, (res)=>{
        let resData = res.data.data.data
        resData.forEach(item=>{
          item.visit_time = item.visit_time ? this.formatTimeSecond(item.visit_time*1000) : ''
          item.deal_time = item.deal_time ? this.formatTimeSecond(item.deal_time*1000) : ''
          item.checked = false
        })
        this.blackListData = resData
        this.isLoading = false
        let obj = {}
        obj.total = Number(res.data.data.total)
        obj.per_page = Number(res.data.data.per_page)
        obj.current_page = Number(res.data.data.current_page)
        obj.last_page = Number(res.data.data.last_page)
        this.allPages = obj  
        this.t_customer_hei = res.data.data.total    
      })
    },
    //获取公共客户池数据
    getCommonData(params){
      this.isLoading = true
      // this.commonCustomerData = []
      if(this.belongID == 'all'){
        params.salesman_id = ''
      }
      params.start_time = params.start_time ? Date.parse(new Date(params.start_time))/1000 : ''
      params.end_time = params.start_time ? Date.parse(new Date(params.end_time))/1000 : ''
      this.postFunc("erp/customer.common.list", params, (res)=>{
        let resData = res.data.data.data
        resData.forEach(item=>{
          item.visit_time = item.visit_time ? this.formatTimeSecond(item.visit_time*1000) : ''
          item.deal_time = item.deal_time ? this.formatTimeSecond(item.deal_time*1000) : ''
          item.checked = false
        })
        this.isLoading = false
        this.commonCustomerData = resData
        let obj = {}
        obj.total = Number(res.data.data.total)
        obj.per_page = Number(res.data.data.per_page)
        obj.current_page = Number(res.data.data.current_page)
        obj.last_page = Number(res.data.data.last_page)
        this.allPages = obj
        this.t_customer_common = res.data.data.total
      })
    },
    //查询 获取下拉列表
    getSelectList(target){
      this.$getSelectList(target).then(res=>{
        this.selectMap[res.target]=res.list;
      })
    },
    //获取今日待办列表数据
    getTodoList(num=1){
      this.isLoading = true
      let obj = Object.assign({}, this.todoParams)
      obj.salesman_id = this.belongID == 'all' ? '' : Number(this.belongID)
      obj.is_today = num
      this.postFunc("erp/customer.visit.backlog", obj, (res)=>{
        let resData = res.data.data.data
        resData.forEach(item=>{
          item.reminder_date = item.reminder_date ? this.formatTime(item.reminder_date*1000) : ''
          item.checked = false
        })
        this.isLoading = false
        this.todoData = res.data.data.data
        let obj = {}
        obj.total = Number(res.data.data.total)
        obj.per_page = Number(res.data.data.per_page)
        obj.current_page = Number(res.data.data.current_page)
        obj.last_page = Number(res.data.data.last_page) 
        this.todoPages = obj
       
      })
    },
    //获取客户采购top10数据
    getPurchaseTop(type=0){
      let salesman_id = this.belongID == 'all' ? '' : this.belongID
      this.postFunc('erp/customer.index.procurement', {type, salesman_id}, res=>{
        this.topCustomer = res.data.data.customer_name      
        let resData = res.data.data.amout
        for(let i = 0; i<resData.length; i++){
          let cur = +resData[i]
          resData[i] = cur.toFixed(4)
        }
        this.topAmount = resData
      })
    },
    //客户归属列表筛选
    selectedSaleman(){
      this.activeName = 'first'
      this.getFilterData()
      this.getStatisticData()
      this.getProfitData()
      this.getCustomerStaData()
      this.getTodoList()   
    },
    //重置
    reset(){    
      this.searchParams=this.resetSearch(this.searchParams)
      this.searchParams.page = 1
      this.search()
      this.getCustomerStaData()
    },
    searchCopy(){
      this.searchParams.page = 1
      this.search()
    },
    search(){
      let obj = Object.assign({}, this.searchParams) 
      obj.salesman_id =  Number(this.belongID) 
      if(this.tabsType != 'first'){
        obj.type = this.tabsType
      }
      if(this.tabsType == '6'){
        this.getCommonData(obj)
        // this.getCustomerStaData()
        return
      }
      if(this.tabsType == '7'){
        this.getBlackListData(obj)
        // this.getCustomerStaData()
        return
      }
      this.getList(obj)
      // this.getCustomerStaData()
    },
    // tabs点击
    handleClick(tab) {
      this.showHistoryMan = false
      if(tab.name == 'todo'){
        this.getTodoList(this.is_today)
        eventBus.$emit("clearToDoSelected")
        return
      }
      if(tab.name == 'last_before'){
        this.getPurchaseTop()
        return
      }

      if(tab.name == 'first'){
        eventBus.$emit('clearSelected')   
      }
      this.tabsType = tab.name
      this.searchParams.page = 1
      this.searchParams.per_page = 20
      let obj = Object.assign({}, this.searchParams) 

      if(obj.hasOwnProperty('field') ){
        delete obj.field
      }
      if(obj.hasOwnProperty('sort') ){
        delete obj.sort
      }   
      obj.salesman_id = this.belongID == 'all' ? '' : Number(this.belongID)
      if(tab.name != 'first' && tab.name != 'todo'){
        obj.type = tab.name
      }else{
        obj.type = ''
      }
      if(tab.name == '6'){
        this.showHistoryMan = true
        // obj.history_salesman_name = ''
        // this.getCommonData(obj)
        this.reset()
        return
      }
      if(tab.name == '7'){
        if(obj.history_salesman_name){
          delete obj.history_salesman_name
        }      
        this.getBlackListData(obj)
        this.getCustomerStaData()
        return
      }
      if(obj.history_salesman_name){
        delete obj.history_salesman_name
      }   
      // this.getList(obj) *******************
      this.reset()
      // this.getCustomerStaData()
    },
    //子组件事件
    handleSonEmit(){
      this.$emit("grandHandle")
    },
    //分页事件触发回调
    handlePageEvent(obj){
      if(this.searchParams.per_page != obj.pagesize){
        this.searchParams.per_page = obj.pagesize
        this.allPages.per_page = obj.pagesize
      }
      if(this.searchParams.page != obj.currentpage){
        this.searchParams.page = obj.currentpage
        this.allPages.current_page = obj.currentpage
      } 
    },
    //待办处理分页事件
    handleTodoPageEvent(obj){
      if(this.todoParams.per_page != obj.pagesize){
        this.todoParams.per_page = obj.pagesize
        this.todoPages.per_page = Number(obj.pagesize) 
      }
      if(this.todoParams.page != obj.currentpage){
        this.todoParams.page = obj.currentpage
        this.todoPages.current_page = Number(obj.currentpage)
      } 
    },
    //待办处理过滤事件
    handleFilterToday(obj){
      this.is_today = obj.is_today
      this.todoParams.page = 1
      this.getTodoList(obj.is_today)
    },
    //待办处理后更新数据
    refreshTodoList(){
      this.getTodoList()
      this.getCustomerStaData()
    },
    //top
    changeTypeEvent(type){ 
      this.getPurchaseTop(type)
    },
    //全部客户 单选事件
    handleSingleSel(val){
      this.allcustomerData.forEach(item=>{
        if(item.id != val){
          item.checked = false
        }
      })
    },
    //刷新全部客户数据
    refreshCustomerData(){ 
      this.getCustomerStaData() 
      this.search()
    },
    //todo single checked event
    handleSingleSelToDo(val){
      this.todoData.forEach(item=>{
        if(item.id != val){
          item.checked = false
        }
      })
    },
    //刷新黑名单数据
    refreshBacklistData(){
      this.search()
      this.getCustomerStaData()
    },
    //刷洗公共池客户数据
    refreshPublicData(){
      this.search()
      this.getCustomerStaData()
    },
    //获取未成交天数配置信息  待删除
    getConfigInfo(){
      this.postFunc("/erp/customer.config.info", {id: 1}, res=>{
        this.unDealDay = res.data.data.value ? res.data.data.value : 90
      })
    },
    //table 列展示
    filterConfirm(){
      this.getFilterData()
      
      this.refresh= false
      this.$nextTick(()=>{
        setTimeout(()=>{ 
          this.activeName = 'first'   
          this.refresh = true
        },1000)
      })
    },
    handleRefreshTodo(){
      this.getTodoList(this.is_today)
      this.getCustomerStaData()
    },
    //全部客户 排序事件回调
    sortAllCustomer(data){
      let params = Object.assign({}, this.searchParams)
      params.field = data.column
      params.sort = data.order
      params.page = 1
      this.searchParams = params
      this.getList(params)
    },
     //estranged 排序事件回调
    sortEstrangedCustomer(data){
      let params = Object.assign({}, this.searchParams)
      params.field = data.column
      params.sort = data.order
      params.page = 1
      params.type = this.tabsType
      this.searchParams = params
      this.getList(params)
    },
    //公共池 黑名单 排序事件回调
    sortCommonCustomer(data){
      let params = Object.assign({}, this.searchParams)
      params.field = data.column
      params.sort = data.order
      params.page = 1
      params.type = this.tabsType
      this.searchParams = params
      this.getCommonData(params)
    },
    sortBlackCustomer(data){
      let params = Object.assign({}, this.searchParams)
      params.field = data.column
      params.sort = data.order
      params.page = 1
      params.type = this.tabsType
      this.searchParams = params
      this.getBlackListData(params)
    }
  },
  mounted(){
    this.getBelongList()
    this.getSelectList("customerSource")
    this.getSelectList("customerAttribute")
    this.getConfigInfo()
  },
  created() { 
    eventBus.$on("refreshTodoListFrom", this.handleRefreshTodo);
  },
  destroyed() {
    eventBus.$off("refreshTodoListFrom");
  },
  watch: {
    "searchParams.page":function(){
      this.search()
    },
    "searchParams.per_page":function(){
      this.search()
    },
    "todoParams.page":function(){
      this.getTodoList(this.is_today)
    },
    "todoParams.per_page":function(){
      this.getTodoList(this.is_today)
    }
  }
}
</script>

<style lang="scss" scoped>
.wb_box{
  .belongs{
    text-align: left;
    background-color: #fff;
    overflow: hidden;
    box-sizing: border-box;
    padding-right: 0px;
    .belong_title{
      float: left;
      width: 70px;
      margin-top: 3px;
      font-size: 14px;
      color: #555;
    }
    .right{
      float: right;
    }
  }
  .mar_top{
    margin-top: 20px;
  }
  .wb_tabs{
    margin-top: 15px;
    
  }
}
.globalFilterBtn{width:17px;height: 17px;position: absolute;bottom:15px;right:15px; background: url(/icon/filterbtn.png) no-repeat 100% 100%;background-size: 100% 100%;}
.globalFilterBtn:hover{background: url(/icon/filterbtnChecked.png) no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}

</style>